(function () {
  const productSliderV1 = () => {
    $(".product-timer-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".js-product-timer-slider");
      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParm = {};
      }
      let swiperParms = {
        parallax: box.data("parallax"),
        speed: box.data("speed") * 1000,
        effect: box.data("effect"),
        loop: true,
        creativeEffect: {
          prev: {
            shadow: true,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        ...autoplayParm,
      };
      const swiper = new Swiper(
        `#${id} .js-product-timer-slider-v1-swiper`,
        swiperParms
      );
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    productSliderV1();
    document.addEventListener("shopify:section:load", function () {
      productSliderV1();
    });
  });
})();
